export default "__VITE_ASSET__DHk0KsUK__"